import _ from "lodash";
import { SkippingFormData } from "./form-store";

export function getSkippingFormErrorMessage(
  formData: SkippingFormData,
  reasonsQueryText: string
) {
  const mustFillOutQuoteInfo = formData.reasons
    .map((r) => r.codeName)
    .includes("price");

  console.log({ formData });
  if (!!reasonsQueryText) {
    return reasonsQueryTextErrorMessage(reasonsQueryText);
  } else if (!_.size(formData.reasons)) {
    return reasonsErrorMessage();
  } else if (!formData.notes.length) {
    return notesErrorMessage();
  } else if (mustFillOutQuoteInfo && !formData.price) {
    return genericErrorMessage("Quoted Price");
  } else if (mustFillOutQuoteInfo && !formData.numTickets) {
    return genericErrorMessage("Quoted Count");
  } else if (mustFillOutQuoteInfo && !formData.flightNumber) {
    return genericErrorMessage("Quoted Flight No.");
  } else if (mustFillOutQuoteInfo && !formData.quoteSource) {
    return genericErrorMessage("Quote Source");
  } else {
    return null;
  }
}
export function getSuspendFormErrorMessage({ notes }) {
  if (!notes.length) {
    return notesErrorMessage();
  } else {
    return null;
  }
}

export function reasonsQueryTextErrorMessage(reasonsQueryText) {
  return `Please transfer the text "${reasonsQueryText}" from the Reasons section into the Notes section`;
}

export function reasonsErrorMessage() {
  return `Please select at least 1 option in the Reasons section`;
}

export function notesErrorMessage() {
  return `Please provide an explanation in the Notes section`;
}

export function genericErrorMessage(fieldName: string) {
  return `Please provide a value for the "${fieldName}" field`;
}
